import { render, staticRenderFns } from "./LessonLabel.vue?vue&type=template&id=817eb5f2&"
import script from "./LessonLabel.vue?vue&type=script&lang=ts&"
export * from "./LessonLabel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports